"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwipeSensitivity = exports.SwipeSensitivity_TapAttachmentSource = void 0;
/* eslint-disable */
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../../google/protobuf/wrappers");
/** the tap source when triggering the attachment by tapping. */
var SwipeSensitivity_TapAttachmentSource;
(function (SwipeSensitivity_TapAttachmentSource) {
    /** UNSET - unset */
    SwipeSensitivity_TapAttachmentSource[SwipeSensitivity_TapAttachmentSource["UNSET"] = 0] = "UNSET";
    /** NONE - isn't triggered by tap */
    SwipeSensitivity_TapAttachmentSource[SwipeSensitivity_TapAttachmentSource["NONE"] = 1] = "NONE";
    /** CARD - tap the card ui */
    SwipeSensitivity_TapAttachmentSource[SwipeSensitivity_TapAttachmentSource["CARD"] = 2] = "CARD";
    /** TRAY - tap the tray ui */
    SwipeSensitivity_TapAttachmentSource[SwipeSensitivity_TapAttachmentSource["TRAY"] = 3] = "TRAY";
    /** END_CARD - tap the end card ui */
    SwipeSensitivity_TapAttachmentSource[SwipeSensitivity_TapAttachmentSource["END_CARD"] = 4] = "END_CARD";
    /** BUTTON - tap the button ui */
    SwipeSensitivity_TapAttachmentSource[SwipeSensitivity_TapAttachmentSource["BUTTON"] = 5] = "BUTTON";
    SwipeSensitivity_TapAttachmentSource[SwipeSensitivity_TapAttachmentSource["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SwipeSensitivity_TapAttachmentSource = exports.SwipeSensitivity_TapAttachmentSource || (exports.SwipeSensitivity_TapAttachmentSource = {}));
function createBaseSwipeSensitivity() {
    return {
        startSwipeTapPositionXRelative: undefined,
        startSwipeTapPositionX: undefined,
        startSwipeTapPositionYRelative: undefined,
        startSwipeTapPositionY: undefined,
        endSwipeTapPositionXRelative: undefined,
        endSwipeTapPositionX: undefined,
        endSwipeTapPositionYRelative: undefined,
        endSwipeTapPositionY: undefined,
        swipeTapDuration: undefined,
        secondPointSwipePositionXRelative: undefined,
        secondPointSwipePositionX: undefined,
        secondPointSwipePositionYRelative: undefined,
        secondPointSwipePositionY: undefined,
        tapAttachmentSource: 0,
    };
}
exports.SwipeSensitivity = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.startSwipeTapPositionXRelative !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.startSwipeTapPositionXRelative }, writer.uint32(10).fork()).ldelim();
        }
        if (message.startSwipeTapPositionX !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.startSwipeTapPositionX }, writer.uint32(18).fork()).ldelim();
        }
        if (message.startSwipeTapPositionYRelative !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.startSwipeTapPositionYRelative }, writer.uint32(26).fork()).ldelim();
        }
        if (message.startSwipeTapPositionY !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.startSwipeTapPositionY }, writer.uint32(34).fork()).ldelim();
        }
        if (message.endSwipeTapPositionXRelative !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.endSwipeTapPositionXRelative }, writer.uint32(42).fork()).ldelim();
        }
        if (message.endSwipeTapPositionX !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.endSwipeTapPositionX }, writer.uint32(50).fork()).ldelim();
        }
        if (message.endSwipeTapPositionYRelative !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.endSwipeTapPositionYRelative }, writer.uint32(58).fork()).ldelim();
        }
        if (message.endSwipeTapPositionY !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.endSwipeTapPositionY }, writer.uint32(66).fork()).ldelim();
        }
        if (message.swipeTapDuration !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.swipeTapDuration }, writer.uint32(74).fork()).ldelim();
        }
        if (message.secondPointSwipePositionXRelative !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.secondPointSwipePositionXRelative }, writer.uint32(82).fork()).ldelim();
        }
        if (message.secondPointSwipePositionX !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.secondPointSwipePositionX }, writer.uint32(90).fork()).ldelim();
        }
        if (message.secondPointSwipePositionYRelative !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.secondPointSwipePositionYRelative }, writer.uint32(98).fork()).ldelim();
        }
        if (message.secondPointSwipePositionY !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.secondPointSwipePositionY }, writer.uint32(106).fork()).ldelim();
        }
        if (message.tapAttachmentSource !== 0) {
            writer.uint32(112).int32(message.tapAttachmentSource);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSwipeSensitivity();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.startSwipeTapPositionXRelative = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.startSwipeTapPositionX = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.startSwipeTapPositionYRelative = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.startSwipeTapPositionY = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 5:
                    message.endSwipeTapPositionXRelative = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 6:
                    message.endSwipeTapPositionX = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 7:
                    message.endSwipeTapPositionYRelative = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 8:
                    message.endSwipeTapPositionY = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 9:
                    message.swipeTapDuration = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 10:
                    message.secondPointSwipePositionXRelative = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 11:
                    message.secondPointSwipePositionX = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 12:
                    message.secondPointSwipePositionYRelative = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 13:
                    message.secondPointSwipePositionY = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 14:
                    message.tapAttachmentSource = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseSwipeSensitivity();
        message.startSwipeTapPositionXRelative =
            object.startSwipeTapPositionXRelative ?? undefined;
        message.startSwipeTapPositionX = object.startSwipeTapPositionX ?? undefined;
        message.startSwipeTapPositionYRelative =
            object.startSwipeTapPositionYRelative ?? undefined;
        message.startSwipeTapPositionY = object.startSwipeTapPositionY ?? undefined;
        message.endSwipeTapPositionXRelative =
            object.endSwipeTapPositionXRelative ?? undefined;
        message.endSwipeTapPositionX = object.endSwipeTapPositionX ?? undefined;
        message.endSwipeTapPositionYRelative =
            object.endSwipeTapPositionYRelative ?? undefined;
        message.endSwipeTapPositionY = object.endSwipeTapPositionY ?? undefined;
        message.swipeTapDuration = object.swipeTapDuration ?? undefined;
        message.secondPointSwipePositionXRelative =
            object.secondPointSwipePositionXRelative ?? undefined;
        message.secondPointSwipePositionX =
            object.secondPointSwipePositionX ?? undefined;
        message.secondPointSwipePositionYRelative =
            object.secondPointSwipePositionYRelative ?? undefined;
        message.secondPointSwipePositionY =
            object.secondPointSwipePositionY ?? undefined;
        message.tapAttachmentSource = object.tapAttachmentSource ?? 0;
        return message;
    },
};
//# sourceMappingURL=swipe_sensitivity.js.map